import * as React from 'react';

const SvgArrowBigRight = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M16.86 11H4v2h12.86l-5.04 6h2.62l5.86-7-5.86-7h-2.62l5.04 6Z" })
);

export { SvgArrowBigRight as default };
//# sourceMappingURL=ArrowBigRight.es.js.map
